import React, { useEffect, useState } from 'react';
import { sanitiseHTML, toType } from 'src/legacy/utils/helpers';
import { ViewMoreActionButton, Typography } from 'src/latest/src/components';
import { countLines } from 'src/latest/src/utils';
import EditButton from '../../../../../../containers/TherapistProfile/Tabs/EditButton';
import './BioSection.scss';

interface Prop {
  value: any;
  secKey: string;
  showPage: any;
}

export const BioSection: React.FC<Prop> = ({ value, secKey, showPage }) => {
  const [showAll, setShowAll] = useState(false);
  const [noOfLines, setNoOfLines] = useState(0);

  useEffect(() => {
    if (value) {
      setNoOfLines(countLines('bio-text'));
    }
  }, [value]);

  return (
    <>
      {value && value?.questions?.length > 0 &&
        value?.questions?.map((question: any, index: number) => {
          return (
            <div
              key={secKey + question?.display_title + index}
              className="w-100 bio-section-container"
            >
              <EditButton section={value} showPage={showPage} />

              <Typography
                variant="size-14"
                weight="bold"
                color="color-28"
                className="new-therapist-profile__title mb-3"
              >
                {question?.display_title}
              </Typography>

              <div
                id="bio-text-section"
                className={`bio-text-section ${
                  showAll ? '' : 'show-less-text'
                } ${noOfLines <= 10 ? 'pb-4' : ''}`}
              >
                {toType(question?.choices) === 'array' &&
                  toType(question?.choices[0]) === 'object' && (
                    <Typography
                      id="bio-text"
                      variant={`size-16`}
                      weight={`regular`}
                      color="color-2"
                    >
                      {question?.choices[0]?.value
                        ? sanitiseHTML(question?.choices[0]?.value)
                        : 'N/A'}
                    </Typography>
                  )}
              </div>

              {question?.choices[0]?.value && noOfLines > 10 && (
                <ViewMoreActionButton
                  showAll={showAll}
                  setShowAll={setShowAll}
                />
              )}
            </div>
          );
        })}
    </>
  );
};
